import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import { conditionalStyle, removeTextUnderlineOnHover } from '@/theme';

import type { SummaryLineProps, SummaryProps } from './AddressSummary';

import { ReactComponent as EditSvg } from '@/assets/edit.svg';

export const Summary = styled(Flex)<Pick<SummaryProps, 'isActive'>>`
  flex-direction: column;
  position: relative;

  ${({ isActive, theme }) => css`
    border: 1px solid
      ${isActive ? theme.colors.primaryLight : theme.colors.mediumGrey};
    padding: ${theme.spacing(2)};
    &:hover {
      border: 1px solid ${theme.colors.primaryLight};
    }
  `}
`;

export const SummaryLine = styled(Typography)<Pick<SummaryLineProps, 'isBold'>>`
  line-height: 22px;

  ${({ isBold, theme }) => css`
    ${conditionalStyle(isBold, 'font-weight', theme.fontWeights.bold)}
  `}
`;

export const SummaryEdit = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: ${({ theme }) => theme.spacing(2)};
  cursor: pointer;

  ${removeTextUnderlineOnHover};
`;

export const EditIcon = styled(EditSvg)`
  height: 22px;
`;

export const IconWrapper = styled(Box)`
  cursor: pointer;
`;
